import { useState } from 'react';
import { getTimeWithTimeZone, downloadLocalFile } from 'utility/general';
import CustomLink from 'components/CustomLink';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { useDispatch, useSelector } from 'react-redux';
import { SET_LOCAL_SAE_REPORT } from 'store/key';
import API from 'api/call';

const useUploadDocData = ({
    localSAEReport,
    rows,
}) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const getDownloadDocument = (row) => {
        const canDownloadServerFile = localSAEReport?.remoteDocIds?.includes(row.id);
        if (canDownloadServerFile) {
            dispatch({
                type: GET_DOWNLOAD_DOCUMENT,
                payload: {
                    data: {
                        id: row.id,
                    },
                    apiUrl: API.postApprovalActivities.downloadDocument,
                },
            });
        } else {
            /** download local file */
            downloadLocalFile(row.tempFile);
        }
    };

    const getFileNameContent = (params) => {
        let fileName = params.getValue('fileName');
        return <CustomLink isStopJumping isChangeColor onClick={() => getDownloadDocument(params.row)}>
            {fileName}
        </CustomLink>;
    };

    const defaultUploadDocFormList = {
        fileName: {
            alignItems: 'baseline',
            value: [],
            label: 'File Name',
            name: 'fileName',
            type: 'uploadFile',
            multiple: true,
            validators: ['isRequired'],
            enableRemove: true,
        },
    };

    const columns = [
        {
            field: 'createDtm',
            headerName: 'Upload Date',
            width: 200,
            valueGetter: (params) => {
                let date = params.getValue('createDtm');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
        { field: 'createdBy', headerName: 'Uploaded By', width: 200 },
        {
            field: 'fileName',
            headerName: 'File',
            width: 300,
            valueGetter: (params) => getFileNameContent(params),
        },
    ];

    const [showUploadDocDialog, setShowUploadDocDialog] = useState(false);
    const handleUploadDocUpdate = (row) => {
        const { firstName, surname } = user?.detail;

        let newData = [];
        const newRows = row.fileName.map((item, index) => {
            newData.push(item.key);
            return {
                id: item.key,
                uploadTempId: item.key,
                createDtm: new Date(),
                createdBy: surname + ' ' + firstName,
                fileName: item.name,
                tempFile: item.tempFile,
            };
        });

        dispatch({
            type: SET_LOCAL_SAE_REPORT,
            payload: {
                rows: [...rows, ...newRows],
                remoteDetail: {
                    ...localSAEReport.remoteDetail,
                    addSupplements: [...localSAEReport.remoteDetail.addSupplements, ...newData]
                }
            },
        });
    };

    const handleUploadDocDelete = (row) => {
        const index = rows.findIndex(item => item.id === row.id);
        let copyRows = [...rows];
        copyRows.splice(index, 1);

        let deleteSupplements = localSAEReport.remoteDetail.deleteSupplements;
        let addSupplements = localSAEReport.remoteDetail.addSupplements;
        if (localSAEReport.remoteDocIds.includes(row.id)) {
            deleteSupplements.push(row.id);
        };

        if (addSupplements.includes(row.id)) {
            const index = addSupplements.findIndex(i => i === row.id);
            addSupplements.splice(index, 1);
        };

        dispatch({
            type: SET_LOCAL_SAE_REPORT,
            payload: {
                rows: copyRows,
                remoteDetail: {
                    ...localSAEReport.remoteDetail,
                    deleteSupplements,
                    addSupplements,
                },
            },
        });
    };


    return {
        columns,
        defaultUploadDocFormList,
        showUploadDocDialog,
        setShowUploadDocDialog,
        handleUploadDocUpdate,
        handleUploadDocDelete,
    };
};
export default useUploadDocData;
